import { render, staticRenderFns } from "./SubjectRegister.vue?vue&type=template&id=2bd2a168"
import script from "./SubjectRegister.vue?vue&type=script&lang=js"
export * from "./SubjectRegister.vue?vue&type=script&lang=js"
import style0 from "./SubjectRegister.vue?vue&type=style&index=0&id=2bd2a168&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports